import { onMounted, ref } from 'vue'
import { useToast } from 'primevue/usetoast'
import { toTypedSchema } from '@vee-validate/zod'
import { useFieldArray, useForm } from 'vee-validate'
import { customerSchema } from '@/schemas/customerSchema'
import { getCustomerById } from '@/api/customers'
import { useRouter } from 'vue-router'
import type { Customer } from '@/types/customer-types'
import {locationData } from '@/constants/customers'
import{addressTypeData} from '@/constants/index'

export const useCustomerForm = (formType: 'add' | 'edit' | 'view'): any => {
  const { values, handleSubmit, errors, setErrors, resetForm, meta } = useForm({
    validationSchema: toTypedSchema(customerSchema)
  })

  const {
    push: newAddress,
    remove: removeAddress,
    fields: addressFields
  } = useFieldArray('addresses')
  const loading = ref(false)
  const toast = useToast()
  const router = useRouter()

  const showToast = (type: 'success' | 'error', title: string, message: string) => {
    toast.add({
      severity: type,
      summary: title,
      detail: message,
      life: 5000
    })
  }

  const getCustomerLocationAndCountry = (addresses: any) => {
    return addresses.map((address: any) => {
      const location = locationData.find((location) => location.id === address.location)
      const addressType = addressTypeData.find((addressType) => addressType.id === address.addressType)
      return { ...address, location: location, addressType: addressType }
    })
  }

  onMounted(async () => {
    if (formType !== 'add') {
      const customerId = router.currentRoute.value.params.id as string
      const customer: Customer = await getCustomerById(customerId)

      if (customer) {
        const addresses = getCustomerLocationAndCountry(customer.addresses)
        resetForm({
          values: { ...customer, addresses }
        })
      }
    }
  })

  return {
    values,
    errors,
    meta,
    handleSubmit,
    setErrors,
    addressFields,
    newAddress,
    removeAddress,
    showToast,
    loading,
    formType
  }
}
